// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__20usn","checkboxCol":"Table_checkboxCol__3QMHm","emailCol":"Table_emailCol__19WWX","actionCol":"Table_actionCol__2e53x"};